import React, { useState } from 'react';
import localization from 'assets/localization/localization';
import DatePicker from 'components/sales/datePicker/datePicker';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DropDownInput from '../Input/dropDownInput/dropDownInput';

const SalaryMasterFilter = ({
  applyFilter,
}) => {
  const filterInputs = {
    phone_number:'',
    month: '',
    year: '',
    status: ''
  };

  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
      }}
    >
      <DropDownInput
        label="Status"
        data={[
          {
            id: "PENDING",
            name: "PENDING",
          },
          {
            id: "SYSTEM_CALCULATED",
            name: "SYSTEM_CALCULATED",
          },
          {
            id: "OPS_CALCULATED",
            name: "OPS_CALCULATED",
          },
          {
            id: "OPS_FREEZED",
            name: "OPS_FREEZED",
          },
          {
            id: "OPS_APPROVED",
            name: "OPS_APPROVED",
          },
          {
            id: "OPS_REJECTED",
            name: "OPS_REJECTED",
          },
          {
            id: "FINANCE_MODIFICATION_REQUESTED",
            name: "FINANCE_MODIFICATION_REQUESTED",
          }
        ]}
        getIdValue={(val) => {
          setFilterFieldsData({ ...filterFieldsData, status: val?.id });
        }}
        value={window.localStorage?.filterDataSalary && window.localStorage?.filterDataSalary ? JSON.parse(window.localStorage?.filterDataSalary)['status'] : ""}
      />
      <ConstantInput
        label={'Phone Number'}
        type="number"
        maxLength={10}
        value={window.localStorage?.filterDataSalary && window.localStorage?.filterDataSalary ? JSON.parse(window.localStorage?.filterDataSalary)['phone_number'] : ""}
        handleChange={(value) => {
            setFilterFieldsData({ ...filterFieldsData, phone_number: value });
        }}
      />
      <ConstantInput
        label={'Month'}
        type="number"
        handleChange={(value) => {
            setFilterFieldsData({ ...filterFieldsData, month: value });
        }}
        value={window.localStorage?.filterDataSalary && window.localStorage?.filterDataSalary ? JSON.parse(window.localStorage?.filterDataSalary)['month'] : ""}
      />
      <ConstantInput
        label={'Year'}
        type="number"
        handleChange={(value) => {
            setFilterFieldsData({ ...filterFieldsData, year: value });
        }}
        value={window.localStorage?.filterDataSalary && window.localStorage?.filterDataSalary ? JSON.parse(window.localStorage?.filterDataSalary)['year'] : ""}
      />
      {/* <DatePicker
          handleChange={(val) =>
            setFilterFieldsData({ ...filterFieldsData, to_date: val })
          }
          label={`To Date`}
          required={false}
      /> */}
      
      <br />
      <br />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            applyFilter(filterInputs);
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default SalaryMasterFilter;
